/**
 * Der Vorgangszugang ohne Konto -- F4-35.
 *
 * **Drei Aufrufe, alle ohne Anmeldung.** Sie sind die einzigen im Portal, die
 * kein Sitzungstoken mitschicken (`withoutSession`): Wer aus einer Mail auf
 * den Link klickt, hat im Zweifel noch eine abgelaufene Portalsitzung im
 * Browser, und die haette hier nur Fehlermeldungen erzeugt.
 *
 * **Das Merkmal geht im Kopfeintrag mit und nicht in der Adresse.** Es
 * oeffnet einen Schriftwechsel -- und eine Adresse landet im
 * Zugriffsprotokoll des Webservers, im Verlauf des Browsers und in jedem
 * `Referer`, den die Seite ausloest. Es wird deshalb auch nicht in
 * `localStorage` abgelegt: Es gilt eine Stunde, und wer die Seite neu laedt,
 * kommt ueber den Link aus seiner Mail in einem Zug wieder herein.
 */

import type { components } from '../../api/schema';
import { request } from '../../lib/apiClient';

export type TicketAccess = components['schemas']['TicketAccessRead'];
export type TicketAccessTicket = components['schemas']['TicketAccessTicket'];
export type TicketAccessArticle = components['schemas']['TicketAccessArticle'];

const HEADER = 'X-Ticket-Access';

export function openTicketAccess(email: string, ticketNumber: string): Promise<TicketAccess> {
  return request<TicketAccess>('/public/tickets/access', {
    method: 'POST',
    body: { email, ticket_number: ticketNumber },
    withoutSession: true,
  });
}

export function readTicketAccess(token: string): Promise<TicketAccess> {
  return request<TicketAccess>('/public/tickets/view', {
    headers: { [HEADER]: token },
    withoutSession: true,
  });
}

export function replyWithTicketAccess(token: string, bodyHtml: string): Promise<TicketAccess> {
  return request<TicketAccess>('/public/tickets/reply', {
    method: 'POST',
    headers: { [HEADER]: token },
    body: { body_html: bodyHtml },
    withoutSession: true,
  });
}
